import { SendBtnComponent } from '@web-components/buttons/send-btn/send-btn';
import { EditBtnComponent } from '@web-components/buttons/edit-btn/edit-btn';
import { SettingsBtnComponent } from '@web-components/buttons/settings-btn/settings-btn';
import { SnWarningComponent } from '@components/common/sn-warning/sn-warning';
import { DeleteBtnComponent } from '@web-components/buttons/delete-btn/delete-btn';
import { ClientCardComponent } from '@web-components/client/client-card/client-card';
import { EnableClientsOptInComponent } from '@web-components/client/enable-clients-opt-in/enable-clients-opt-in';
import { JobClientComponent } from '@web-components/client/job-client/job-client';
import { SaveOptinConsentModalComponent } from '@components/base/client/modals/save-optin-consent-modal/save-optin-consent-modal';
import { InvoiceUpdateDnd } from '@web-components/invoices/invoice-update/invoice-update-dnd/invoice-update-dnd';
import { QuoteClientInfoComponent } from '@web-components/quotes/common/quote-client-info/quote-client-info';
import { QuoteCreatePackageComponent } from '@web-components/quotes/common/quote-create-package-block/quote-create-package-block';
import { QuoteJobInfoComponent } from '@web-components/quotes/common/quote-job-info/quote-job-info';
import { QuoteUpdateComponent } from '@web-components/quotes/quote-update/quote-update';
import { PaymentScheduleComponent } from '@web-components/quotes/common/payment-schedule/payment-schedule';
import { QuoteContractAndQuestionComponent } from '@web-components/quotes/common/quote-contract-and-question/quote-contract-and-question';
import { QuoteSummaryBlockComponent } from '@web-components/quotes/common/quote-summary-block/quote-summary-block';
import { EnableGdprSectionComponent } from '@web-components/settings/gdpr/enable-gdpr-section/enable-gdpr-section';
import { ContractSignatureComponent } from '@web-components/contract/contract-signature/contract-signature';
import { CloseBtnComponent } from '@components/common/buttons/close-btn/close-btn';
import { SnLabelComponent } from '@components/common/sn-label/sn-label';
import { OptInAgreementComponent } from '@components/common/opt-in-agreement/opt-in-agreement';
import { SubscribeClientBtnComponent } from '@web-components/buttons/subscribe-client-btn/subscribe-client-btn';
import { ClientPhotoWebComponent } from '@web-components/client/client-photo/client-photo';
import { ClientSubscribeInfoWebComponent } from '@web-components/client/client-subscribe-info/client-subscribe-info';
import { ResubscribeClientModalWebComponent } from '@web-components/client/modals/resubscribe-client-modal/resubscribe-client-modal';
import { UploadPhotoModalWebComponent } from '@web-components/client/modals/upload-photo-modal/upload-photo-modal';
import { QuestionnaireSubmittedStatementComponent } from '@components/common/questionnaire-submitted-statement/questionnaire-submitted-statement';
import { TermsUpdatedModalComponent } from '@web-components/common/terms-updated-modal/terms-updated-modal';
import { WorkflowExitModalComponent } from '@web-components/settings/workflow-exit-modal/workflow-exit-modal';
import { WarningSignImgComponent } from '@components/common/warning-sign-img/warning-sign-img';
import { SearchbarComponent } from '@web-components/common/searchbar/searchbar';
import { SnPaginationComponent } from '@web-components/common/sn-pagination/sn-pagination';
import { ConsentListWebComponent } from '@web-components/client/consent-list/consent-list';
import { CancelBtnComponent } from '@mob-components/buttons/cancel-btn/cancel-btn';
import { ErrorMessageModalWebComponent } from '@web-components/common/error-message-modal/error-message-modal';
import { AutocompleteEmailInputComponent } from '@web-components/inputs/autocomplete-email-input/autocompete-email-input';
import { AttachmentsComponent } from '@mob-components/files/attachments/attachments';
import { EventTypeRowComponent } from '@web-components/common/event-type-row/event-type-row';
import { AddRoundBtnComponent } from '@web-components/buttons/add-round-btn/add-round-btn';
import { SimplePaginationComponent } from '@web-components/buttons/simple-pagination/simple-pagination';
import { ShootsAppointmentsBlockComponent } from '@web-components/dashboard/shoots-appointments-block/shoots-appointments-block';
import { RecentLeadsBlockComponent } from '@web-components/dashboard/recent-leads-block/recent-leads-block';
import { DeleteLeadModalComponent } from '@web-components/leads/modals/delete-lead-modal/delete-lead-modal';
import { UserMenuComponent } from '@web-components/navbar/user-navbar/user-menu/user-menu';
import { DragAndDropBlockComponent } from '@web-components/dashboard/drag-and-drop-block/drag-and-drop-block';
import { GraphsBlockComponent } from '@web-components/dashboard/graphs-block/graphs-block';
import { UpcomingPaymentsBlockComponent } from '@web-components/dashboard/upcoming-payments-block/upcoming-payments-block';
import { RecordPaymentModalComponent } from '@web-components/payments/modals/record-payment-modal/record-payment-modal';
import { WriteOffModalComponent } from '@web-components/payments/modals/write-off-modal/write-off-modal';
import { JobTaskBlockComponent } from '@web-components/dashboard/job-task-block/job-task-block';
import { DeleteJobModalComponent } from '@web-components/jobs/modals/delete-job-modal/delete-job-modal';
import { SnDateRangePickerComponent } from '@web-components/common/sn-date-range-picker/sn-date-range-picker.component';
import { UploadComponent } from '@web-components/common/upload-component/upload-component';
import { ProselectUploadComponent } from '@web-components/common/proselect-upload-component/proselect-upload-component';
import { SnDatePickerComponent } from '@web-components/common/sn-date-picker/sn-date-picker.component';
import { PackageInfoPanelComponent } from '@web-components/quotes/package-info-panel/package-info-panel.component';
import { PriceTagComponent } from '@web-components/price-tag/price-tag.component';
import { JobFilesModalComponent } from '@web-components/common/sn-tiny-editor/job-files-modal/job-files-modal.component';
import { MainShootDateComponent } from '@components/common/main-shoot-date/main-shoot-date';
import { QuoteViewComponent } from '@web-components/quote/quote-view/quote-view';
import { PrintBtnComponent } from '@web-components/buttons/print-btn/print-btn';
import { ModalDeleteQuoteComponent } from '@web-components/quote/modals/modal-delete-quote/modal-delete-quote';
import { QuoteInfoComponent } from '@web-components/quote/common/quote-info/quote-info';
import { QuoteFromInfoComponent } from '@web-components/quote/common/quote-from-info/quote-from-info';
import { ModalSendQuoteComponent } from '@web-components/quote/modals/modal-send-quote/modal-send-quote';
import { PackagesProductBlockComponent } from '@web-components/packages-product/packages-product-block/product-packages-block.component';
import { PackagesBlockComponent } from '@web-components/packages-product/packages-block/packages-block.component';
import { ProductBlockComponent } from '@web-components/packages-product/product-block/product-block.component';
import { UpdatePackageProductModalComponent } from '@web-components/packages-product/modals/update-package-product-modal/update-package-product-modal.component';
import { AddonsTableComponent } from '@web-components/quotes/addons-table/addons-table.component';
import { ProductDetailsModalComponent } from '@web-components/quotes/modals/product-details-modal/product-details-modal.component';
import { AddNewElementBtnComponent } from '@web-components/buttons/add-new-element-btn/add-new-element-btn.component';
import { AddQuoteTypeModalComponent } from '@web-components/quotes/modals/add-quote-type-modal/add-quote-type-modal.component';
import { QuoteViewFixedComponent } from '@web-components/quote/quote-view-fixed/quote-view-fixed';
import { ProductPackageTableComponent } from '@web-components/quotes/product-package-table/product-package-table';
import { QuoteAssignmentPanelComponent } from '@web-components/quote/quote-assignment-panel/quote-assignment-panel.component';
import { InvoiceViewComponent } from '@web-components/invoices/invoice-view/invoice-view';
import { InvoiceInfoTableComponent } from '@web-components/invoices/invoice-view/invoice-info-table/invoice-info-table';
import { InvoicePaymentsScheduleTable } from '@web-components/invoices/invoice-view/invoice-payments-schedule-table/invoice-payments-schedule-table';
import { ModalMakeInvoiceComponent } from '@web-components/quote/modals/modal-make-invoice/modal-make-invoice';
import { ShowMoreContentComponent } from '@web-components/common/show-more-content/show-more-content.component';
import { DiscountCreateBlockComponent } from '@web-components/quotes/common/discount-create-block/discount-create-block.component';
import { DiscountViewBlockComponent } from '@web-components/quotes/common/discount-view-block/discount-view-block.component';
import { MarkQuoteAsAcceptedModal } from '@web-components/quote/modals/mark-quote-as-accepted/mark-quote-as-accepted.modal';
import { PreviewBtnComponent } from '@web-components/buttons/preview-btn/preview-btn';
import { CopyToXeroBtnComponent } from '@web-components/buttons/copy-to-xero-btn/copy-to-xero-btn';
import { CopyToQbBtnComponent } from '@web-components/buttons/copy-to-qb-btn/copy-to-qb-btn';
import { DeleteInvoiceModalComponent } from '@web-components/invoices/modals/delete-invoice-modal/delete-invoice-modal';
import { InvoicePaymentActionButtons } from '@web-components/invoices/invoice-view/invoice-payments-action-buttons/invoice-payment-action-buttons';
import { SavePdfBtnComponent } from '@web-components/buttons/save-pdf-btn/save-pdf-btn';
import { InvoiceClientInfoComponent } from '@web-components/invoices/invoice-update/invoice-client-info/invoice-client-info';
import { InvoiceContractQuestionComponent } from '@web-components/invoices/invoice-update/invoice-contract-question/invoice-contract-question';
import { InvoiceJobInfoComponent } from '@web-components/invoices/invoice-update/invoice-job-info/invoice-job-info';
import { InvoiceMainInfoComponent } from '@web-components/invoices/invoice-update/invoice-main-info/invoice-main-info';
import { InvoicePaymentScheduleComponent } from '@web-components/invoices/invoice-update/invoice-payment-schedule/invoice-payment-schedule';
import { InvoiceSummaryComponent } from '@web-components/invoices/invoice-update/invoice-summary/invoice-summary';
import { InvoiceUpdateComponent } from '@web-components/invoices/invoice-update/invoice-update';
import { GalleryViewBlockComponent } from '@web-components/integrations/connect-galleries/gallery-view-block/gallery-view-block.component';
import { DeleteGalleryModal } from '@web-components/integrations/connect-galleries/modals/delete-gallery-modal/delete-gallery.modal';
import { AddGalleryModal } from '@web-components/integrations/connect-galleries/modals/add-gallery-modal/add-gallery.modal';
import { CreateNewGalleryModal } from '@web-components/integrations/connect-galleries/modals/create-new-gallery-modal/create-new-gallery.modal';
import { SelectExistingGalleryModal } from '@web-components/integrations/connect-galleries/modals/select-existing-gallery-modal/select-existing-gallery.modal';
import { DeleteConfirmationModal } from '@web-components/integrations/connect-galleries/modals/delete-confirmation-modal/delete-confirmation.modal';
import { SubscriptionCardComponent } from '@web-components/subscription/modals/subscription-modal/subscription-card/subscription-card';
import { SubscriptionModalComponent } from '@web-components/subscription/modals/subscription-modal/subscription-modal';
import { InvoicesViewBlockComponent } from '@web-components/invoices/invoices-view-block/invoices-view-block.component';
import { ShootproofInvoicesBlockComponent } from '@web-components/invoices/shootproof-invoices-block/shootproof-invoices-block.component';
import { PaymentsOverviewComponent } from '@web-components/payments/payments-overview/payments-overview.component';
import { CopyInvoiceToQuickBooksModal } from '@web-components/invoices/modals/copy-invoice-to-quickBooks/copy-invoice-to-quickBooks.modal';
import { ProfileComponent } from '@web-components/settings/profile/profile';
import { AccountDetailsComponent } from '@web-components/settings/profile/account-details/account-details';
import { LoginChangeComponent } from '@web-components/settings/profile/login-change/login-change';
import { PasswordChangeComponent } from '@web-components/settings/profile/password-change/password-change';
import { SubscriptionChangeComponent } from '@web-components/settings/profile/subscription-change/subscription-change';
import { SubscriptionPeriodChangeComponent } from '@web-components/subscription/modals/subscription-modal/subscription-period-change/subscription-period-change';
import { IframeComponent } from '@web-components/common/iframe/iframe.component';
import { CancelSubscriptionModalComponent } from '@web-components/settings/profile/subscription-change/modals/cancel-subscription/cancel-subscription-modal';
import { CancelSubscriptionConfirmModalComponent } from '@web-components/settings/profile/subscription-change/modals/cancel-subscription-confirm/cancel-subscription-confirm-modal';
import { BtnSubscriptionComponent } from '@web-components/buttons/btn-subscription/btn-subscription';
import { SnQuillEditorWebComponent } from '@web-components/common/sn-quill-editor/sn-quill-editor-web';
import { SnQuillLinkModal } from '@web-components/common/sn-quill-editor/modals/sn-quill-link-modal/sn-quill-link-modal';
import { WebAttachmentsComponent } from '@web-components/common/sn-quill-editor/attachments/attachments.component';
import { SnQuillAttachmentModal } from '@web-components/common/sn-quill-editor/modals/sn-quill-attachment-modal/sn-quill-attachment.modal';
import { ContactFormSectionComponent } from '@web-components/settings/contact-form-section/contact-form-section';
import { TemplateListComponent } from '@web-components/settings/common/template-list/template-list';
import { SettingSectionHeaderComponent } from '@web-components/settings/common/setting-section-header/setting-section-header';
import { SettingSectionDescriptionComponent } from '@web-components/settings/common/setting-section-description/setting-section-description';
import { SettingsAddBtnComponent } from '@web-components/buttons/settings-add-btn/settings-add-btn';
import { DeleteItemModalComponent } from '@web-components/settings/common/delete-item-modal/delete-item-modal';
import { SubscriptionAnnouncementBannerComponent } from '@web-components/subscription/subscription-announcement-banner/subscription-announcement-banner';
import { SubscriptionChoosePlanComponent } from '@web-components/subscription/subscription-choose-plan/subscription-choose-plan';
import { DiscountBlockComponent } from '@web-components/packages-product/discount-block/discount-block.component';
import { UpdateDiscountModal } from '@web-components/packages-product/modals/update-discount-modal/update-discount-modal.component';
import { EditContractModalComponent } from '@web-components/contract/edit-contract-modal/edit-contract-modal.component';
import { EmailReplyModalComponent } from '@web-components/settings/email-settings-section/modals/email-reply-modal/email-reply-modal.component';
import { CompaniesSectionComponent } from '@web-components/settings/companies-section/companies-section.component';
import { SettingsOverviewComponent } from '@web-components/settings/settings-overview/settings-overview.component';
import { SettingsItemComponent } from '@web-components/settings/settings-overview/settings-item/settings-item.component';
import { SettingsNavigationComponent } from '@web-components/settings/settings-overview/settings-navigation/settings-navigation.component';
import { UserNavbarComponent } from '@web-components/navbar/user-navbar/user-navbar.component';
import { BrandCreateModalComponent } from '@web-components/brands/modals/brand-create-modal/brand-create-modal';
import { ImportDataModalComponent } from '@web-components/brands/modals/import-data-modal/import-data-modal';
import { RejectImportModalComponent } from '@web-components/brands/modals/reject-import-modal/reject-import-modal';
import { EditCompanySectionComponent } from '@web-components/settings/edit-company-section/edit-company-section';
import { ToggleComponent } from '@web-components/common/toggle/toggle.component';
import { MediaDropZoneComponent } from '@web-components/common/media-drop-zone/media-drop-zone.component';
import { GdprDisableModalComponent } from '@web-components/brands/modals/gdpr-disable-modal/gdpr-disable-modal';
import { ButtonsHandlerComponent } from '@web-components/common/buttons-handler/buttons-handler.component';
import { AlertModalComponent } from '@web-components/common/alert-modal/alert-modal.component';
import { DeleteCompanyModalComponent } from '@web-components/settings/companies-section/delete-company-modal/delete-company.modal';
import { CustomMediaPreviewComponent } from '@web-components/common/media-drop-zone/custom-media-preview/custom-media-preview.component';
import { DateTimeCalendarComponent } from '@web-components/settings/date-time-calendar/date-time-calendar';
import { CustomizeLabelsComponent } from '@web-components/settings/customize-labels/customize-labels';
import { ConfirmReSyncModal } from '@web-components/settings/date-time-calendar/confirm-re-sync-modal/confirm-re-sync-modal';
import { CompanyListItemComponent } from '@web-components/settings/companies-section/company-list-item/company-list-item.component';
import { ExportPaymentsModalComponent } from '@web-components/payments/modals/export-payments-modal/export-payments-modal';
import { ExportJobsModalComponent } from '@web-components/jobs/modals/export-jobs-modal/export-jobs-modal';
import { ExportLeadsModalComponent } from '@web-components/leads/modals/export-leads-modal/export-leads-modal';
import { ArchiveBtnComponent } from '@web-components/buttons/archive-btn/archive-btn';
import { ReSyncBtnComponent } from '@web-components/buttons/re-sync-btn/re-sync-btn';
import { QuestionnaireSectionComponent } from '@web-components/settings/questionnaire-section/questionnaire-section';
import { QuestionnaireTemplateListComponent } from '@web-components/settings/common/questionnaire-template-list/questionnaire-template-list';
import { QuestionnaireComponent } from '@web-components/questionnaire/questionnaire';
import { ReplyTrackComponent } from '@web-components/settings/email-settings-section/components/reply-track/reply-track.component';
import { SmtpModalComponent } from '@web-components/settings/email-settings-section/modals/smtp-modal/smtp-modal.component';
import { EmailReplyConfirmModalComponent } from '@web-components/settings/email-settings-section/modals/email-reply-confirm-modal/email-reply-confirm-modal.component';
import { EmailAlertModalComponent } from '@web-components/settings/email-settings-section/modals/email-alert-modal/email-alert-modal.component';
import { JobFileSectionComponent } from '@web-components/jobs/sections/job-file-section/job-file-section.component';
import { JobCellHeader } from '@web-components/common/job-cell-header/job-cell-header';
import { BtnAddFile } from '@web-components/jobs/common/btn-add-file/btn-add-file';
import { BtnDeleteFile } from '@web-components/jobs/common/btn-delete-file/btn-delete-file';
import { DeleteAttachmentModal } from '@web-components/jobs/common/delete-atachment-modal/delete-attachment-modal';
import { EditContractButton } from '@web-components/jobs/modals/edit-contract-button/edit-contract-button';
import { SaveContractPdf } from '@web-components/jobs/modals/save-contract-pdf/save-contract-pdf';
import { SnQuillWebViewComponent } from '@web-components/common/sn-quill-view/sn-quill-view-web';
import { IntegrateWithXeroV2Modal } from '@web-components/settings/integrations-section/modals/integrate-with-xero-v2/integrate-with-xero-v2-modal';
import { TwoFaSettingsComponent } from '@web-components/settings/profile/two-fa-settings/two-fa-settings';
import { TwoFaSetupModalComponent } from '@web-components/2fa/modals/two-fa-setup-modal/two-fa-setup-modal';
import { TwoFaLoginModalComponent } from '@web-components/2fa/modals/two-fa-login-modal/two-fa-login-modal';
import { TwoFaResetModalComponent } from '@web-components/2fa/modals/two-fa-reset-modal/two-fa-reset-modal';
import { TwoFaControlComponent } from '@web-components/2fa/two-fa-control/two-fa-control.component';
import { EnterCodeComponent } from '@web-components/2fa/modals/two-fa-setup-modal/enter-code/enter-code.component';
import { SetUpQuestionsComponent } from '@web-components/2fa/modals/two-fa-setup-modal/set-up-questions/set-up-questions.component';
import { QuestionItemComponent } from '@web-components/2fa/modals/two-fa-setup-modal/set-up-questions/question-item/question-item.component';
import { GetAuthenticatorComponent } from '@web-components/2fa/modals/two-fa-setup-modal/get-authenticator/get-authenticator.component';
import { ConfirmGeneralModalComponent } from '@web-components/common/confirm-general-modal/confirm-general-modal.component';
import { ManageUser2faModal } from '@web-components/2fa/modals/manage-user-2fa-modal/manage-user-2fa-modal';
import { IconTooltipComponent } from '@components/common/tooltips/icon-tooltip/icon-tooltip.component';
import { LeadSourcesSectionComponent } from '@web-components/settings/lead-sources-section/lead-sources-section';
import { ManageLeadSourceModalComponent } from '@web-components/settings/lead-sources-section/modals/manage-lead-source-modal/manage-lead-source-modal.component';
import { DeleteLeadSourceModalComponent } from '@web-components/settings/lead-sources-section/modals/delete-lead-source-modal/delete-lead-source-modal.component';
import { DynamicTableComponent } from '@web-components/settings/common/dynamic-table/dynamic-table.component';
import { LeadSourceColorComponent } from '@components/common/lead-source-color/lead-source-color';
import { LeadSourcesGraphSectionComponent } from '@web-components/dashboard/graphs-block/lead-sources-graph-section/lead-sources-graph-section.component';
import { ViewAllLeadSourcesModalComponent } from '@web-components/dashboard/modals/view-all-lead-sources/view-all-lead-sources-modal';
import { LeadSourcesGraphComponent } from '@web-components/dashboard/graphs-block/lead-sources-graph/lead-sources-graph.component';
import { InvoiceNumberingComponent } from '@web-components/settings/invoice-payments-section/components/invoice-numbering/invoice-numbering.component';
import { IntegrationsSection } from '@web-components/settings/integrations-section/integrations-section';
import { IntegrateXeroModal } from '@web-components/settings/integrations-section/modals/integrate-xero-modal/integrate-xero-modal';
import { IntegrateShootProofModal } from '@web-components/settings/integrations-section/modals/integrate-shoot-proof-modal/integrate-shoot-proof-modal';
import { IntegrateQuickBooksModal } from '@web-components/settings/integrations-section/modals/integrate-quick-books-modal/integrate-quick-books-modal';
import { PreIntegratePickTimeModal } from '@web-components/settings/integrations-section/modals/pre-integrate-pick-time-modal/pre-integrate-pick-time-modal';
import { IntegratePicTimeModal } from '@web-components/settings/integrations-section/modals/integrate-pic-time-modal/integrate-pic-time-modal';
import { PicTimeInvoicesBlockComponent } from '@web-components/invoices/pic-time-invoices-block/pic-time-invoices-block.component';
import { CopyInvoiceToQuickBooksOrXeroModal } from '@web-components/invoices/modals/copy-invoice-to-qb-or-xero/copy-invoice-to-qb-or-xero.modal';

export const downgradedComponents = [
	SnLabelComponent,
	SnWarningComponent,
	SettingsBtnComponent,
	ResubscribeClientModalWebComponent,
	TermsUpdatedModalComponent,
	SaveOptinConsentModalComponent,
	BtnSubscriptionComponent,
	JobClientComponent,
	SendBtnComponent,
	EditBtnComponent,
	EnableGdprSectionComponent,
	UploadPhotoModalWebComponent,
	CloseBtnComponent,
	ClientCardComponent,
	DeleteBtnComponent,
	SubscribeClientBtnComponent,
	OptInAgreementComponent,
	ContractSignatureComponent,
	QuestionnaireSubmittedStatementComponent,
	EnableClientsOptInComponent,
	ClientPhotoWebComponent,
	ClientSubscribeInfoWebComponent,
	WorkflowExitModalComponent,
	WarningSignImgComponent,
	WorkflowExitModalComponent,
	SearchbarComponent,
	SnPaginationComponent,
	WorkflowExitModalComponent,
	ConsentListWebComponent,
	ArchiveBtnComponent,
	CancelBtnComponent,
	ErrorMessageModalWebComponent,
	AttachmentsComponent,
	ShootsAppointmentsBlockComponent,
	EventTypeRowComponent,
	AddRoundBtnComponent,
	SimplePaginationComponent,
	RecentLeadsBlockComponent,
	DeleteLeadModalComponent,
	UserMenuComponent,
	DeleteLeadModalComponent,
	DragAndDropBlockComponent,
	GraphsBlockComponent,
	UpcomingPaymentsBlockComponent,
	RecordPaymentModalComponent,
	WriteOffModalComponent,
	JobTaskBlockComponent,
	DeleteJobModalComponent,
	GraphsBlockComponent,
	SnDateRangePickerComponent,
	SnDatePickerComponent,
	UploadComponent,
	ProselectUploadComponent,
	JobFilesModalComponent,
	QuoteUpdateComponent,
	MainShootDateComponent,
	QuoteJobInfoComponent,
	QuoteClientInfoComponent,
	QuoteCreatePackageComponent,
	PaymentScheduleComponent,
	QuoteContractAndQuestionComponent,
	JobFilesModalComponent,
	QuoteCreatePackageComponent,
	QuoteViewComponent,
	PrintBtnComponent,
	ModalDeleteQuoteComponent,
	QuoteInfoComponent,
	QuoteFromInfoComponent,
	ModalSendQuoteComponent,
	PackageInfoPanelComponent,
	PriceTagComponent,
	QuoteSummaryBlockComponent,
	PackagesProductBlockComponent,
	PackagesBlockComponent,
	ProductBlockComponent,
	UpdatePackageProductModalComponent,
	ProductDetailsModalComponent,
	AddonsTableComponent,
	MainShootDateComponent,
	AutocompleteEmailInputComponent,
	AddNewElementBtnComponent,
	AddQuoteTypeModalComponent,
	InvoiceUpdateDnd,
	QuoteViewFixedComponent,
	ProductPackageTableComponent,
	QuoteAssignmentPanelComponent,
	ReSyncBtnComponent,
	InvoiceViewComponent,
	InvoiceInfoTableComponent,
	InvoicePaymentsScheduleTable,
	PreviewBtnComponent,
	CopyToXeroBtnComponent,
	CopyToQbBtnComponent,
	DeleteInvoiceModalComponent,
	InvoicePaymentActionButtons,
	SavePdfBtnComponent,
	SnQuillWebViewComponent,
	ShowMoreContentComponent,
	DiscountCreateBlockComponent,
	DiscountViewBlockComponent,
	InvoiceClientInfoComponent,
	InvoiceContractQuestionComponent,
	InvoiceJobInfoComponent,
	InvoiceMainInfoComponent,
	InvoicePaymentScheduleComponent,
	InvoiceSummaryComponent,
	InvoiceUpdateComponent,
	ModalMakeInvoiceComponent,
	MarkQuoteAsAcceptedModal,
	GalleryViewBlockComponent,
	DeleteGalleryModal,
	AddGalleryModal,
	CreateNewGalleryModal,
	SelectExistingGalleryModal,
	DeleteConfirmationModal,
	MarkQuoteAsAcceptedModal,
	InvoicePaymentsScheduleTable,
	ShowMoreContentComponent,
	DiscountCreateBlockComponent,
	DiscountViewBlockComponent,
	CompaniesSectionComponent,
	SubscriptionModalComponent,
	SubscriptionCardComponent,
	InvoicesViewBlockComponent,
	ShootproofInvoicesBlockComponent,
	CopyInvoiceToQuickBooksModal,
	PaymentsOverviewComponent,
	ProfileComponent,
	AccountDetailsComponent,
	LoginChangeComponent,
	PasswordChangeComponent,
	SubscriptionChangeComponent,
	SubscriptionPeriodChangeComponent,
	IframeComponent,
	CancelSubscriptionModalComponent,
	CancelSubscriptionConfirmModalComponent,
	SubscriptionAnnouncementBannerComponent,
	SubscriptionChoosePlanComponent,
	SnQuillEditorWebComponent,
	SnQuillLinkModal,
	WebAttachmentsComponent,
	SnQuillAttachmentModal,
	ContactFormSectionComponent,
	TemplateListComponent,
	QuestionnaireTemplateListComponent,
	SettingSectionHeaderComponent,
	SettingSectionDescriptionComponent,
	SettingsAddBtnComponent,
	DeleteItemModalComponent,
	DiscountBlockComponent,
	UpdateDiscountModal,
	DeleteItemModalComponent,
	EditContractModalComponent,
	EmailReplyModalComponent,
	SettingsOverviewComponent,
	DeleteItemModalComponent,
	SettingsItemComponent,
	SettingsNavigationComponent,
	SettingsItemComponent,
	UserNavbarComponent,
	BrandCreateModalComponent,
	ImportDataModalComponent,
	RejectImportModalComponent,
	EditCompanySectionComponent,
	ToggleComponent,
	MediaDropZoneComponent,
	GdprDisableModalComponent,
	ButtonsHandlerComponent,
	AlertModalComponent,
	CustomMediaPreviewComponent,
	DateTimeCalendarComponent,
	CustomizeLabelsComponent,
	DeleteCompanyModalComponent,
	ConfirmReSyncModal,
	CompanyListItemComponent,
	EmailReplyConfirmModalComponent,
	EmailAlertModalComponent,
	ExportPaymentsModalComponent,
	ExportJobsModalComponent,
	ExportLeadsModalComponent,
	QuestionnaireSectionComponent,
	QuestionnaireComponent,
	ReplyTrackComponent,
	SmtpModalComponent,
	ExportLeadsModalComponent,
	JobFileSectionComponent,
	JobCellHeader,
	BtnAddFile,
	BtnDeleteFile,
	DeleteAttachmentModal,
	EditContractButton,
	SaveContractPdf,
	IntegrateWithXeroV2Modal,
	TwoFaSettingsComponent,
	TwoFaSetupModalComponent,
	TwoFaLoginModalComponent,
	TwoFaResetModalComponent,
	TwoFaControlComponent,
	GetAuthenticatorComponent,
	SetUpQuestionsComponent,
	QuestionItemComponent,
	EnterCodeComponent,
	ConfirmGeneralModalComponent,
	ManageUser2faModal,
	IconTooltipComponent,
	LeadSourcesSectionComponent,
	ManageLeadSourceModalComponent,
	DeleteLeadSourceModalComponent,
	DynamicTableComponent,
	LeadSourceColorComponent,
	LeadSourcesGraphSectionComponent,
	LeadSourcesGraphComponent,
	ViewAllLeadSourcesModalComponent,
	InvoiceNumberingComponent,
	SaveContractPdf,
	SmtpModalComponent,
	IntegrationsSection,
	IntegrateXeroModal,
	IntegrateShootProofModal,
	IntegrateQuickBooksModal,
	PreIntegratePickTimeModal,
	IntegratePicTimeModal,
	PicTimeInvoicesBlockComponent,
	CopyInvoiceToQuickBooksOrXeroModal
];



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/modernComponents.ts